// extracted by mini-css-extract-plugin
export default {"appLayout":"index_appLayout__Fhdq2","sideNav":"index_sideNav__oeg4o","appInfo":"index_appInfo__JQyVX","sideNavMenu":"index_sideNavMenu__lUUbP"};